<template>
  <div class="p-1">
    <div class="flex justify-between">
      <a-button :to="{ name: 'disponibility_schedules' }">
        Ver disponibilidades
      </a-button>
      <a-button :to="{ name: 'show_schedules' }" class="w-full md:w-auto">
        Ver horarios
      </a-button>
    </div>
    <div class="mt-2">
      <course-section-accessor
        v-model="courseSection"
        @loading="handleLoadingAccessor"
      />
    </div>

    <template v-if="loadingCourseSection">
      <div class="flex -mx-2 flex-wrap">
        <div class="px-2 w-full md:w-1/3 lg:w-1/3" v-for="n in 3" :key="n">
          <a-skeleton class="w-full h-14" />
        </div>
      </div>
    </template>

    <div>
    <div class="mt-2 flex flex-wrap -mx-2">
      <template v-if="courseSection">
        <div class="mt-2 w-full md:w-1/3 lg:w-1/4 px-2">
          <a-card>
            <template #header>
              <div class="flex justify-between items-center">
                <p>Profesor</p>
                
                <a-dropdown search dontOverflow v-if="!courseSection.teacher_id">
                  <button @click="openActions">
                    Asignar
                  </button>
                  <template #menu class="p-4">
                    <template >
                        <!-- <a-input type="search" class="px-2" v-model="search" /> -->
                      <v-select
                        multiple
                        style="width: 300px;"
                        v-model="selectedTeachers"
                        @input="handleTeacherSelect"
                        placeholder="Selecciona uno o más profesores"
                        show-search
                        :options="teachers"
                      ></v-select>
                      <dropdown-item v-if="!courseSection.teacher_id" @click.native="assignMultipleTeachers">
                        <button
                          class="mt-2 px-4 py-2 w-full rounded-lg bg-blue-500 text-white"
                          @click="assignMultipleTeachers"
                          :disabled="selectedTeachers.length === 0"
                        >
                          Asignar
                        </button>
                      </dropdown-item>
                    </template>
                  </template>
                </a-dropdown>
                <a-dropdown search dontOverflow v-else>
                  <button @click="openActions">
                    cambiar
                  </button>
                  <template #menu>
                    <a-dropdown-item
                        class="w-full"
                        v-for="teacher in teach"
                        :key="teacher.id"
                        @click="changeTeacher(teacher.value, true)">
                      {{ teacher.label }}
                    </a-dropdown-item>
                  </template>
                </a-dropdown>
              </div>
            </template>
            <h4 class="text-center">
              {{ courseSection.teacher_id ? selectedTeacher.full_name : 'Sin profesor asignado' }}        
                </h4>
          </a-card>
        </div>
        <div class="mt-2 w-full md:w-2/3 lg:w-3/4 px-2">
          <calendar
            :selected-teacher="selectedTeacher"
            :course-section="courseSection"
            @stored="handleFetch"
            @updated="handleFetch"
          />
        </div>
      </template>
      <template v-else>
        <h4 class="text-center w-full p-8 text-2xl">
          Por favor, llene todos los campos para iniciar la búsqueda.
        </h4>
      </template>
    </div>
  </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapState, mapGetters, mapActions } from "vuex";
import CourseSectionAccessor from "@/components/ui/course-section-accessor.vue";
import Calendar from "./calendar";
import DropdownItem from "../../components/ui/dropdown/DropdownItem.vue";
export default {
  components: {
    DropdownItem,
    vSelect,
    CourseSectionAccessor,
    Calendar,
  },
  data: () => ({
    selectionFilters: {
      period_id: null,
    },
    courseSection: null,
    loadingCourseSection: false,
    search: "",
    showTeacherSelect: true,
    teach: [],
    selectedTeacher: {},
    selectedTeachers: []

  }),
  computed: {
    ...mapGetters(["error"]),
    ...mapState({
      loadingPeriods: ({ periods }) => periods.loading,
      teachers: ({ teachers }) =>
        teachers.all.map(($0) => ({
          label: `${$0.first_name} ${$0.last_name}`,
          value: $0.id,
        })),
    }),

    allTeachers() {
      console.log('allteachers',this.courseSection.teachers)
      return this.courseSection && this.courseSection.teachers
        ? this.courseSection.teachers
        : [];
        
    },
    availableTeachers() {
      let teachers = this.allTeachers;
      if (this.courseSection && this.courseSection.teacher_id) {
        teachers = teachers.filter(
          (t) => t.id !== this.courseSection.teacher_id
        );
      }
      return teachers.map((t) => ({
        label: t.full_name || `${t.first_name} ${t.last_name}`,
        id: t.id,
        value: t.id,
      }));
    },
    selectedTeacherNames() {
      if (this.courseSection && this.courseSection.teacher_ids && this.courseSection.teacher_ids.length) {
        return this.teachers
          .filter(t => this.courseSection.teacher_ids.includes(t.value))
          .map(t => t.full_name);
      }
      return [];
    }
  },
  watch: {
    search(e) {
      this.teach = this.teachers.filter((teacher) =>
        teacher.label.toLowerCase().includes(e.toLowerCase())
      );
    },
    courseSection: {
    immediate: true,
    handler(newVal) {
      if (newVal) {
        console.log("Datos de courseSection:", newVal);
        
        if (!newVal.teacher_id && newVal.teachers && newVal.teachers.length > 0) {
          const firstTeacher = newVal.teachers[0];
          this.courseSection.teacher_id = firstTeacher.id;
          this.courseSection.teacher = firstTeacher;
          this.selectedTeacher = firstTeacher;
          this.teach = this.availableTeachers;
          console.log("selectedTeacher asignado (sin teacher_id):", this.selectedTeacher);
        } else if (newVal.teacher_id) {
          let teacher = newVal.teacher;
          if (!teacher && newVal.teachers && newVal.teachers.length > 0) {
            teacher = newVal.teachers.find(t => t.id === newVal.teacher_id);
          }
          if (teacher) {
            this.selectedTeacher = teacher;
          } else {
            this.selectedTeacher = {};
          }
          this.teach = this.availableTeachers;
          console.log("selectedTeacher asignado (con teacher_id):", this.selectedTeacher);
        } else {
          this.teach = this.teachers;
          console.log("courseSection sin asignación previa", this.teachers);
        }
      } else {
        this.teach = [];
      }
    },
  },
  },
  methods: {
    ...mapActions({
      fetchTeachers: "teachers/index",
      assign: "sections/assignTeacherToSectionCourse",
    }),
    openActions() {
      this.teach = this.availableTeachers;
    },
    handleLoadingAccessor(event) {
      this.loadingCourseSection = event;
    },
    handleTeacherSelect(newSelection) {
    const teacher_ids = newSelection.map(item => item.value);
    this.courseSection.teacher_ids = teacher_ids;
    
    if (teacher_ids.length > 0) {
      const teacherFound = this.availableTeachers.find(t => t.value === teacher_ids[0]);
      if (teacherFound) {
        this.courseSection.teacher_id = teacherFound.value;
        this.courseSection.teacher = teacherFound;
        this.selectedTeacher = teacherFound;
      }
    }
  },
    changeTeacher(teacher_id, hasTeacher) {
      console.log("teacher_id",teacher_id)
      
      if(hasTeacher){
        const findTeacher = this.allTeachers.find((t) => t.id === teacher_id);
        console.log("findTeacher ==:> ",findTeacher)
        if (findTeacher) {
          this.courseSection.teacher_id = teacher_id;
          this.courseSection.teacher = findTeacher;
          this.selectedTeacher = findTeacher;
        }
      } 
    },
    assignMultipleTeachers() {
  if (this.selectedTeachers.length === 0) return;
  this.loadingCourseSection = true;
  
  // Se obtiene un arreglo con los IDs seleccionados
  console.log("selectedTeachers ====> ",this.selectedTeachers)
  const newTeachers = [ ...this.selectedTeachers ];
  console.log("newTeachers ----->",newTeachers)

  const teacher_ids = this.selectedTeachers.map(t => t.value);
  const payload = { ...this.courseSection, teacher_ids };
  
  this.assign(payload)
    .then(() => {
      this.$message.success("Profesores asignados correctamente");
      this.$repository.courseSections.show(
        this.courseSection.section_id,
        this.courseSection.course_id,
        { with: "teachers" }
      ).then((res) => {
        const newData = res.data;
        this.courseSection = { ...newData, teacher_id: teacher_ids[0] };
        this.showTeacherSelect = false;
        console.log('teacher_id asignado:', this.courseSection.teacher_id);
        this.selectedTeachers = [];
        console.log('then =======>',this.selectedTeachers)
        if (newData.teachers && newData.teachers.length > 0) {
          const firstAssigned = { ...newData.teachers[0] };
          this.teach = [ ...newData.teachers ];
          this.selectedTeacher = firstAssigned || {};
          console.log('if===============>0', this.selectedTeacher)
        } else {
          console.log('else===============>0', this.selectedTeacher)

          this.selectedTeacher = {};
          this.teach = [];
        }
      });
    })
    .catch((error) => {
      console.error("Error al asignar múltiples profesores:", error);
      this.$message.error("Error al asignar los profesores");
    })
    .finally(() => {
      this.loadingCourseSection = false;
    });
},

    handleFetch() {
      let requests = [
        this.fetchTeachers({
          enabled: true,
          limit: 0,
          order_by: "last_name,asc",
        }),
      ];

      if (this.$route.query.course && this.$route.query.section) {
        requests.unshift(
          this.$repository.courseSections.show(
            this.$route.query.section,
            this.$route.query.course,
            {
              with: `teacher`,
            }
          )
        );

        Promise.all(requests).then(([{ data }]) => {
          this.courseSection = data;
        });
      }
    },
  },
  mounted() {
    this.handleFetch();
  },
};
</script>
